import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,
    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator,
    Text,
    PermissionsAndroid,
    Linking, I18nManager,
    Image, Clipboard
} from "react-native";


import {scale, moderateScale, verticalScale} from '../../../../tools/Scaling';


// import HMActionBarSatia from "../../customviews/HMActionBarSatia";


import i18n from '../../../../I18n/i18n.js';
//import HMImageBackground from "../../customviews/HMImageBackground";

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from "../../../../redux/NavigationService";
import HMTextView from "../../../../customviews/HMTextView";
import Colors from "../../../../tools/Colors";


import {connect} from "react-redux";

import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import {Tools} from "../../../../tools/Tools";
import HMIcon from "../../../../customviews/HMIcon";
import HMImageView from "../../../../customviews/HMImageView";
import Toast from "../../../../customviews/toast";
import {isMobile} from "react-device-detect";

let container = null

class IntroduceFriendsChildSatiaScreen extends Component {


    constructor(props) {
        super(props);
        container = this;
        this.state = {
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            indexSelectType: 0,
            // list: [],
            list: props.route && props.route.params && props.route.params.list ? props.route.params.list : (this.props.user && this.props.user.customers ? this.props.user.customers : []),
            DescriptionSelectCheckBoxIntroduceFriends: null,
            indexSelectCheckBoxIntroduceFriends: null,
            /*    list: [
                    {
                        Serial: 1,
                        Name: 'رایانکده آپادانا',
                        Type: 'Wireless',

                    },
                    {
                        Serial: 2,
                        Name: 'وحید قایم مقامی',
                        Type: 'Wireless',

                    },
                    {
                        Serial: 3,
                        Name: 'وحید قایم مقامی',
                        Type: 'Wireless',

                    },
                    {
                        Serial: 4,
                        Name: 'دانشکده علوم پزشکی نهاوند',
                        Type: 'TD-LTE',

                    },
                    {
                        Serial: 5,
                        Name: 'وحید قایم مقامی',
                        Type: 'TD-LTE',

                    },
                    {
                        Serial: 6,
                        Name: 'ساتیا',
                        Type: 'TD-LTE',

                    },
                    {
                        Serial: 7,
                        Name: 'وحید قایم مقامی',
                        Type: 'ADSL',

                    },


                ],*/
            listFilter: []
        };

        // props.callServiceRefresh();


    }

    componentDidMount() {

        // if (store.getState().reducerSplashGetAllData.TypeLogin == 2)
        //this.getData()

    }


    /*  getData() {

          this.setState({
              //ShowImage:true
              isLoading: true,
              NoInternetDialog: false,

          })


          const formData = new FormData();
          formData.append('lang', i18n.locale);
          formData.append('token', this.props.token);


          const config = {
              headers: {
                  "Content-Type": "multipart/form-data; charset=utf-8;",
                  // 'Content-Type': 'application/json',
                  // "Authorization": `Basic ${params.token}`,
                  timeout: Constants._TIMEOUT_FILE
              }
          };

          axios.post(typeExport._baseUrlSatia + "services/customerGigs", formData, config)
              .then(async response => {
                  let data = response.data;
                  let list = response.data.result && response.data.result.data ? response.data.result.data : response.data.result;


                  // data.status ? this.state.listImage.push(image) : null;

                  this.setState({
                      //ShowImage:true
                      list: data.status ? list : this.state.list,
                      //TypeDocumentsList:[],
                      isLoading: false,
                      NoInternetDialog: !data.status,

                  })
              }).catch((e) => {

              this.setState({
                  //ShowImage:true
                  isLoading: false,
                  NoInternetDialog: true,

              })
          })
      }*/

    render() {
        // let {} = this.props.route.params
        let item = this.props.route.params ? this.props.route.params.item : null

        let account = this.props.DataSplashSatiaScreen.Account;
        let info = this.props.DataSplashSatiaScreen.results.info;
        let url = info.linkIntroduceFriends + account.Serial;

        return (
            <View style={{position: 'relative', flex: 1}}>


                {/*     <HMImageBackground

                />*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        <HMActionBarSatia
                            menu={account}
                            back={account}
                            props={this.props} statusBarTransparent
                            text={"معرفی به دوستان"}
                            // text={item ? (item.name ? item.name : (item.title ? item.title : '')) : "اشتراک ها"}
                            //   text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}
                            LeftView={
                                Platform.OS === "web" && !(isMobile) ?
                                    null
                                    :
                                    <TouchableOpacity
                                        style={{
                                            //   backgroundColor: Colors.red,
                                            //    marginHorizontal: moderateScale(10),
                                            width: moderateScale(24),
                                            height: moderateScale(48),

                                            justifyContent: 'center',
                                            alignItems: 'center',
                                        }}

                                        onPress={

                                            //  onBackPress
                                            () => {
                                                Tools.onShare(item);

                                            }
                                        }
                                    >
                                        <HMIcon name={"ios-share-social-outline"}
                                                style={{fontSize: moderateScale(26), color: Colors.white}}/>


                                        {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                        {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                    </TouchableOpacity>

                            }

                        />


                        <ScrollView>
                            <View
                                style={{
                                    flex: 1,
                                    margin: moderateScale(10),
                                    backgroundColor: Colors.white,
                                    borderRadius: moderateScale(8),
                                    padding: moderateScale(10)
                                }}>

                                <HMTextView

                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    text={info.introduceFriends.suggestionTitle} type={"bold"}
                                    style={{
                                        fontSize: moderateScale(13),
                                        marginVertical: moderateScale(6),
                                        marginHorizontal: moderateScale(4),
                                        color: Colors.colorDarkText
                                    }}/>
                                <HMTextView

                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    text={"متن پیشنهادی تبلیغ : "}
                                    //type={"bold"}
                                    style={{
                                        fontSize: moderateScale(13),
                                        marginVertical: moderateScale(6),
                                        marginHorizontal: moderateScale(4),
                                        color: Colors.colorDarkText
                                    }}/>
                                {
                                    info.introduceFriends.link ?
                                        <View
                                            style={{
                                                width: "100%",
                                                margin: moderateScale(2),
                                                backgroundColor: "#f2f2f2",
                                                borderRadius: moderateScale(8),
                                                padding: moderateScale(10)
                                            }}>


                                            <HMTextView
                                                text={info.introduceFriends.suggestionDescription2}
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                //                                         text={`سلام
                                                // من قبلا با سرعت اینترنت مشکل داشتم و از وقتی ساتیا خریدم مشکلم حل شد و راضی هستم اگر با سرعت یا قیمت اینترنت خودتان مشکل دارید فروش ویژه پائیزه ساتیا بنام انار نت را امتحان کنید
                                                // انارنت با 1500 گیگابایت تقریبا نامحدود هست و سرعت 8 تا 16 مگابیت دارد و با قیمت 90 هزار تومان ارائه می شود
                                                // ساتیا بدلیل اینکه من معرف شما هستم 30 هزار تومان تخفیف ویژه به شما  خواهد داد
                                                // اگر دوست داشتید روی این لینک کلیک کنید و شماره خودتان را وارد کنید تا با شما تماس بگیرند
                                                // `}

                                                type={"bold"}
                                                style={{
                                                    fontSize: moderateScale(13),
                                                    marginVertical: moderateScale(6),
                                                    marginHorizontal: moderateScale(4),
                                                    color: Colors.colorDarkText
                                                }}/>
                                            <TouchableOpacity
                                             //   style={{backgroundColor:"#ee82a0"}}
                                                disabled={Platform.OS !== "web"}
                                                onPress={()=>{
                                                    Tools.GoLink(info.introduceFriends.link + account.Serial)
                                                }}

                                            >
                                                <HMTextView
                                                    type={"bold"}
                                                    text={info.introduceFriends.link + account.Serial}
                                                    style={{
                                                        alignSelf: 'center',
                                                        //  marginRight: moderateScale(6),
                                                        // margin: moderateScale(6),
                                                        textAlign: 'center',
                                                        color: Colors.blue,
                                                        fontSize: moderateScale(14),
                                                    }}
                                                    styleRoot={{alignSelf: "center", marginVertical: moderateScale(10),borderBottomWidth: moderateScale(2),borderBottomColor:Colors.blue}}
                                                />

                                            </TouchableOpacity>
                                            <View style={{flex: 1, flexDirection: "row"}}>
                                                <TouchableOpacity
                                                    style={[{
                                                        flexDirection: 'row',
                                                        //  //justifyContent: "flex-end",
                                                        //alignItems: "flex-start",
                                                        width: '48%',
                                                        height: moderateScale(48),
                                                        // margin: moderateScale(4),
                                                        // alignSelf: 'center',
                                                        backgroundColor: Colors.white,
                                                        borderRadius: moderateScale(8),
                                                        //  marginHorizontal: moderateScale(10),
                                                        alignItems: 'center',
                                                        justifyContent: 'center',

                                                    }]}
                                                    onPress={() => {
                                                        if (Platform.OS === "web") {
                                                            navigator.clipboard.writeText(info.introduceFriends.suggestionDescription2 + "\n" + info.introduceFriends.link + account.Serial)

                                                        }
                                                        else {
                                                            if (Clipboard)
                                                                Clipboard.setString(info.introduceFriends.suggestionDescription2 + "\n" + info.introduceFriends.link + account.Serial)
                                                        }
                                                        Toast.show({
                                                            // type: 'success | error | info',
                                                            type: 'custom_info',
                                                            //  type: data.status ? 'custom_success' : 'custom_error',
                                                            //  position: 'top | bottom',
                                                            position: 'top',
                                                            text1: i18n.t('constant.message'),
                                                            text2: "پیام کپی شد",
                                                            visibilityTime: 4000,
                                                            autoHide: true,
                                                            //  topOffset: 30,
                                                            // bottomOffset: 40,
                                                            onShow: () => {
                                                            },
                                                            onHide: () => {
                                                            }
                                                        })
                                                    }

                                                    }>
                                                    <HMIcon name={"copy1"}
                                                            type={"AntDesign"}
                                                            style={{
                                                                textAlign: 'center',
                                                                //alignSelf: 'flex-end',
                                                                color: Colors.blackLight,
                                                                // width: moderateScale(29),
                                                                // height: moderateScale(29),
                                                                fontSize: moderateScale(20)
                                                            }}/>
                                                    <View style={{width: moderateScale(2)}}/>
                                                    <HMTextView text={`(کپی کردن پیام)`} style={{
                                                        alignSelf: 'center',
                                                        //  marginRight: moderateScale(6),
                                                        // margin: moderateScale(6),
                                                        textAlign: 'center',
                                                        color: Colors.colorDarkText,
                                                        fontSize: moderateScale(13),
                                                    }}/>
                                                </TouchableOpacity>
                                                <View style={{flex: 1}}/>
                                                {
                                                    Platform.OS === "web" && !(isMobile) ?
                                                        null
                                                        :
                                                        <TouchableOpacity
                                                            style={[{
                                                                flexDirection: 'row',
                                                                //  //justifyContent: "flex-end",
                                                                //alignItems: "flex-start",
                                                                width: '48%',
                                                                height: moderateScale(48),
                                                                // margin: moderateScale(4),
                                                                //  alignSelf: 'center',
                                                                //  marginHorizontal: moderateScale(10),
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                backgroundColor: Colors.white,
                                                                borderRadius: moderateScale(8)
                                                            }]}
                                                            onPress={
                                                                () => {
                                                                    Tools.onShare({
                                                                        link_url: info.introduceFriends.link + account.Serial,
                                                                        description: info.introduceFriends.suggestionDescription2,

                                                                    });

                                                                }
                                                            }>
                                                            <HMIcon name={"share-alt-square"}
                                                                    type={"FontAwesome"}
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        //alignSelf: 'flex-end',
                                                                        color: Colors.blackLight,
                                                                        // width: moderateScale(29),
                                                                        // height: moderateScale(29),
                                                                        fontSize: moderateScale(20)
                                                                    }}/>
                                                            <View style={{width: moderateScale(2)}}/>
                                                            <HMTextView text={`اشتراگ گذاری مستقیم`} style={{
                                                                alignSelf: 'center',
                                                                //  marginRight: moderateScale(6),
                                                                // margin: moderateScale(6),
                                                                textAlign: 'center',
                                                                color: Colors.colorDarkText,
                                                                fontSize: moderateScale(13),
                                                            }}/>
                                                        </TouchableOpacity>
                                                }

                                            </View>
                                        </View>
                                        :
                                        null
                                }


                            </View>
                        </ScrollView>
                    </KeyboardAvoidingView>
                </View>


            </View>
        );
    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                //   ['indexSelectCheckBox' + name]: check ? null : (item.id ? item.id : item.value)
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value),
                ['DescriptionSelectCheckBox' + name]: (item.description)
            },
            () => {
            })
    }

}

const mapStateToProps = state => {
    return {

        user: state.reducerSplashSatiaScreen.user,
        token: state.reducerSplashSatiaScreen.token,
        DataSplashSatiaScreen: state.reducerSplashSatiaScreen,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        //  callServiceCommentScreen: (url, params, type, typeConnection, page, item_count, token) => dispatch(callWebserviceComment(url, params, type, typeConnection, page, item_count, token)),
        //   callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(IntroduceFriendsChildSatiaScreen);
